import { render, staticRenderFns } from "./TransactionlogPage.vue?vue&type=template&id=20bc6de6&"
import script from "./TransactionlogPage.vue?vue&type=script&lang=js&"
export * from "./TransactionlogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports